import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Blueprint } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";
import useTypedContext from "hooks/useTypedContext";
import { TemplateContext } from "views/Account/Template/Context";

const TemplatesLatestVersionCell = ({
  item: template,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const { template: templateFromContext } = useTypedContext(TemplateContext);
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellLink href={`/template/${templateFromContext.id}/version/${template.id}`}>
        {template.version}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default TemplatesLatestVersionCell;
